import { count } from './count';
import { counts } from './counts';
import { search } from './search';

export default {
  search,
  counts,
  count,
};
